import { AlertColor } from '@mui/material';
import { createEvent, createStore } from 'effector';
import { ReactNode } from 'react';

export type FeedbackData = {
  severity: AlertColor;
  title?: ReactNode;
  message?: ReactNode;
};

export const createFeedbackPanelModel = () => {
  const setFeedbackData = createEvent<FeedbackData | null>();
  const $feedbackData = createStore<FeedbackData | null>(null).on(setFeedbackData, (_, data) => data);

  return {
    $feedbackData,
    setFeedbackData
  };
};

export type FeedbackPanelModel = ReturnType<typeof createFeedbackPanelModel>;
